// extracted by mini-css-extract-plugin
export default {"switchWrapper":"uhH8I","switchInput":"tnj3e","switchContainer":"DYd8H","switch":"ULIFb","switchText":"GSACE","switchCircle":"sxxYC","withoutBump":"HXDcU","widthBump":"Nngc_"};